/** The patient's name on Claim and Touch detail rows (reviews #69, #70). PHI. */

/**
 * The Patient column's getter for Claim or Touch detail rows, or null when the file
 * carries no names (built before reviews #69/#70, or the build could not read
 * Medevolve's claim worklist) — the pages then show no Patient column at all.
 */
export function patientOf(d: {
  dict: { pt?: string[] }
  cols: { pt?: number[] }
}): ((i: number) => string) | null {
  const names = d.dict.pt
  const codes = d.cols.pt
  return names && codes ? (i) => names[codes[i]!] ?? '' : null
}
